import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { Button, List, ListItemButton } from "@mui/material";
import { BootstrapDialog } from "../MaterialCustomComponents/ControlPanelComponents";
import { SimpleBox } from "../MaterialCustomComponents";

export interface DialogTitleProps {
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

const InfoButton = ({ handleInfoClick, isMobile }: any) => {
  return (
    <Button
      variant={isMobile ? "controlPanel" : "controlPanelDesktop"}
      onClick={() => handleInfoClick(undefined)}
    >
      <SimpleBox>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 27.9999V13.3333"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16.0508 4H16"
            stroke="white"
            strokeWidth="3.58"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </SimpleBox>
      {!isMobile && (
        <Typography sx={{ color: "#ffffff", fontSize: "0.7rem" }}>
          Booth Info
        </Typography>
      )}
    </Button>
  );
};

export default function BoothInfoComponent({
  isInfoOpen,
  handleInfoClick,
  isMobile = false,
}: any) {
  const handleClose = () => {
    handleInfoClick(undefined);
  };

  const handleClick = (clickedCategory: string) => {
    handleInfoClick(clickedCategory);
  };

  return (
    <div>
      <InfoButton handleInfoClick={handleInfoClick} isMobile={isMobile} />
      <BootstrapDialog
        fullWidth
        onClose={handleClose}
        open={isInfoOpen}
        hideBackdrop={isMobile ? false : true}
        sx={{
          ".MuiDialog-container": {
            justifyContent: isMobile ? "center" : "end",
            alignItems: isMobile ? "center" : "end",
          },
        }}
      >
        <BootstrapDialogTitle onClose={handleClose}>
          Visit Booth:
        </BootstrapDialogTitle>
        <DialogContent dividers>
          <List>
            <ListItemButton onClick={() => handleClick("brochures")}>
              <Typography variant="body1" fontWeight="bold">
                BROCHURES
              </Typography>
            </ListItemButton>
            <ListItemButton onClick={() => handleClick("tv")}>
              <Typography variant="body1" fontWeight="bold">
                VIDEOS
              </Typography>
            </ListItemButton>
            <ListItemButton onClick={() => handleClick("contact")}>
              <Typography variant="body1" fontWeight="bold">
                CONTACT
              </Typography>
            </ListItemButton>
          </List>
        </DialogContent>
      </BootstrapDialog>
    </div>
  );
}
